import React, { useEffect, useState } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";

function Dashboard(props) {
  const [backgroundColor] = React.useState("black");
  const [activeColor] = React.useState("info");
  const [brandName, setbrandName] = React.useState();
  const mainPanel = React.useRef();

  const [search, setSearch] = useState(null);

  const getBrand = () => {
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setbrandName(prop.name);
      }
      return null;
    });
  };
  useEffect(() => {
    getBrand();
  });

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routes}
        bgColor={backgroundColor}
        activeColor={activeColor}
        searchProps={{
          search,
          setSearch,
        }}
      />
      <div className="main-panel" ref={mainPanel}>
        <DemoNavbar
          {...props}
          searchProps={{
            search,
            setSearch,
          }}
        />
        <Switch>
          {routes.map((prop, key) => {
            return (
              <Route
                path={prop.layout + prop.path}
                key={key}
                render={(routeProps) => (
                  <prop.component
                    {...routeProps} // Pass the route props
                    search={search} // Pass the search state
                    setSearch={setSearch} // Pass the setSearch function
                  />
                )}
              />
            );
          })}
        </Switch>
      </div>
    </div>
  );
}

export default Dashboard;